import React, { Component } from "react";
import ReCaptcha from "../common/recaptcha.component";
import { usernameLogin } from "../../services/rest";
import Validator from "../../utils/Validator";

import {
  FORGOT_USERNAME_VALIDATION_ERROR_MESSAGE,
  SUCCESS_ICON_TYPE,
  DEFAULT_API_SUCCESS_TITLE
} from "../../utils/constants";
import ErrorHandler from "../../utils/error-handler";
import TaggingHelper from "../../tagging/tagging-helper";

class ForgotUsername extends Component {
  defaultState = {
    isUsernameValid: false,
    token: null,
    username: "",
    usernameActive: false
  };

  constructor(props) {
    super(props);
    if (props.data && props.data.previousState) {
      this.state = {
        ...props.data.previousState
      };
    } else {
      this.state = this.defaultState;
    }
  }

  onUsernameChange = (e) => {
    this.setState({
      username: e.target.value,
      isUsernameValid:
        Validator.isValidCellphone(e.target.value) ||
        Validator.isValidEmail(e.target.value)
    });
  };

  activateField = (e) => {
    this.setState({
      [`${e.target.name}Active`]: true
    });
  };

  disableField = (e) => {
    this.setState({
      [`${e.target.name}Active`]: false
    });
  };

  _onVerifyCallback = (token) => {
    this.setState({ token, showAlert: false });
  };

  _onExpiredCallback = () => {
    this.setState({ token: null, showRecaptcha: true });
  };

  sendtUsername = (e) => {
    e.preventDefault();
    const { goto } = this.props;
    this.props.showUILoader(true);
    usernameLogin(this.state.username, this.state.token)
      .then((response) => {
        if (response.data && response.data.result && response.status === 200) {
          const message = response.data.result.message || "";
          const successProps = {
            iconType: SUCCESS_ICON_TYPE,
            title: DEFAULT_API_SUCCESS_TITLE,
            message: message,
            primaryButtonInfo: {
              text: "OKAY",
              screen: "LOGIN"
            }
          };
          goto("INFORMATION_CARD", successProps);
          TaggingHelper.forgotUsernameSuccessEvent();
        } else {
          throw new Error("UNEXPECTED_ERROR");
        }
      })
      .catch((error) => {
        const errorMessage = ErrorHandler.getErrorMessage(error).errorMessage;
        TaggingHelper.forgotUsernameErrorEvent(errorMessage);
        ErrorHandler.handleForgotUsernameApiError(
          error,
          goto,
          this.state,
          "FORGOT_USERNAME"
        );
      })
      .finally(() => {
        this.props.showUILoader(false);
      });
  };

  onGoBack = () => {
    this.props.goto("LOGIN");
  };

  gotoRegistration = () => {
    this.props.goto("CREATE_PROFILE");
    TaggingHelper.forgotUsernameRegisterClickEvent();
  };

  componentDidMount() {
    TaggingHelper.forgotUsernameLandingEvent();
  }

  render() {
    const { usernameActive, username, isUsernameValid, token } = this.state;
    return (
      <React.Fragment>
        <div className="card-header">
          <h2>Forgot email/username</h2>
          <p>
            {"Don't have an account yet? "}
            <button
              type="button"
              className="button-link"
              onClick={this.gotoRegistration}
              automationid="LOGIN_FORM_FORGOTUSERNAME_1"
            >
              Register now
            </button>
          </p>
        </div>
        <div className="field-group">
          <label className={usernameActive || username ? "active" : ""}>
            Email or cellphone number
          </label>
          <input
            onChange={this.onUsernameChange}
            value={username}
            type="text"
            name="username"
            required
            onFocus={this.activateField}
            onBlur={this.disableField}
            automationid="LOGIN_FORM_FORGOTUSERNAME_2"
            className={
              !usernameActive && username && !isUsernameValid ? "error" : ""
            }
          />
          {!usernameActive && username && !isUsernameValid && (
            <p className="infield-error-label">
              {FORGOT_USERNAME_VALIDATION_ERROR_MESSAGE}
            </p>
          )}
        </div>
        <div className="captcha-wrapper forgot-uname-captcha-wrapper">
          <ReCaptcha
            sitekey="6LdNAAwUAAAAALEhZyYgkqFtXUPKVhD5Fj2XaWUm"
            verifyCallback={this._onVerifyCallback}
            expiredCallback={this._onExpiredCallback}
          />
        </div>
        <div className="action-button-wrapper">
          <button
            type="submit"
            className="btn btnRed"
            disabled={!token || !isUsernameValid}
            onClick={(e) => this.sendtUsername(e)}
            automationid="LOGIN_FORM_FORGOTUSERNAME_3"
          >
            NEXT
          </button>
        </div>
        <div className="action-button-wrapper">
          <button
            type="button"
            className="btn btnWhite"
            onClick={this.onGoBack}
            automationid="LOGIN_FORM_FORGOTUSERNAME_4"
          >
            BACK
          </button>
        </div>
        <div className="card-footer"></div>
      </React.Fragment>
    );
  }
}

export default ForgotUsername;
